import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggled'];

  toggle(event) {
    event.preventDefault();
    this.toggledTargets.forEach((target) => {
      target.hidden = !target.hidden;
    });
  }
}
